import { render, staticRenderFns } from "./Academy_HAW.vue?vue&type=template&id=179920da"
import script from "./Academy_HAW.vue?vue&type=script&lang=js"
export * from "./Academy_HAW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports